import { RouteRecordRaw } from 'vue-router'

// 学员模块路由
const student: RouteRecordRaw[] = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '首页',
      icon: 'home'
    },
    children:[]
  }, {
    path: '/registration',
    name: 'HomeRegistration',
    component: () => import('@/views/Registration.vue'),
    meta: {
      title: '报名',
      icon: 'registration',
    }
  },{
    path: '/registrationResult',
    name: 'HomeRegistrationResult',
    component: () => import('@/views/RegistrationResult.vue'),
    meta: {
      title: '报名结果',
      icon: 'registration',
    }
  }, {
    path: '/onsite-confirmation',
    name: 'HomeOnsiteConfirmation',
    component: () => import('@/views/OnsiteConfirmation.vue'),
    meta: {
      title: '现场确认',
      icon: 'confirmation',
    }
  }, {
    path: '/courseLearning',
    name: 'courseLearning',
    component: () => import('@/views/CourseLearning/index.vue'),
    meta: {
      title: '课程学习',
      icon: 'confirmation',
    }
  }, {
    path: '/liveSchedule',
    name: 'LiveSchedule',
    component: () => import('@/views/CourseLearning/LiveSchedule.vue'),
    meta: {
      title: '直播课程',
      icon: 'confirmation',
    }
  }, {
    path: '/CourseDetail',
    name: 'CourseDetail',
    component: () => import('@/views/CourseLearning/CourseDetail.vue'),
    meta: {
      title: '课程详情',
      icon: 'confirmation',
    }
  }, {
    path: '/VideoLearning',
    name: 'VideoLearning',
    component: () => import('@/views/CourseLearning/VideoLearning.vue'),
    meta: {
      title: '学习',
      icon: 'confirmation',
    }
  }, {
    path: '/LiveDetail',
    name: 'LiveDetail',
    component: () => import('@/views/CourseLearning/LiveDetail.vue'),
    meta: {
      title: '直播详情',
      icon: 'confirmation',
    }
  }, {
    path: '/LiveBack',
    name: 'LiveBack',
    component: () => import('@/views/CourseLearning/LiveBack.vue'),
    meta: {
      title: '直播回放',
      icon: 'confirmation',
    }
  }, {
    path: '/LiveReservation',
    name: 'LiveReservation',
    component: () => import('@/views/CourseLearning/LiveReservation.vue'),
    meta: {
      title: '直播预约',
      icon: 'confirmation',
    }
  }, {
    path: '/proIntroduction',
    name: 'proIntroduction',
    component: () => import('@/views/proIntroduction.vue'),
    meta: {
      title: '项目简介',
      icon: 'confirmation',
    }
  }, {
    path: '/supportCenter',
    name: 'supportCenter',
    component: () => import('@/views/supportCenter/index.vue'),
    meta: {
      title: '学习服务中心',
      icon: 'confirmation',
    }
  }, {
    path: '/QueryResult',
    name: 'QueryResult',
    component: () => import('@/views/QueryResult.vue'),
    meta: {
      title: '审核结果',
      icon: 'confirmation',
    }
  }, {
    path: '/RegistrationProcess',
    name: 'RegistrationProcess',
    component: () => import('@/views/RegistrationProcess.vue'),
    meta: {
      title: '报名流程',
      icon: 'confirmation',
    }
  }, {
    path: '/payment',
    name: 'Payment',
    component: () => import('@/views/Payment.vue'),
    meta: {
      title: '在线缴费',
      icon: 'payment',
    }
  }, {
    path: '/paymentResult',
    name: 'PaymentResult',
    component: () => import('@/views/PaymentResult.vue'),
    meta: {
      title: '缴费结果',
      icon: 'payment',
    }
  }, {
    path: '/announcement',
    name: 'AnnouncementList',
    component: () => import('@/views/Announcement/AnnouncementList.vue'),
    meta: {
      title: '通知公告',
      icon: 'announcement',
    }
  }, {
    path: '/announcement/:id',
    name: 'AnnouncementDetail',
    component: () => import('@/views/Announcement/AnnouncementDetail.vue'),
    meta: {
      title: '公告详情',
      icon: 'announcement',
    }
  }
]

export default student 